import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api } from "@/lib/api";

export default function PortalDocuments() {
  const [trip, setTrip] = useState(null);
  useEffect(() => { api.get("/portal/trip").then((r) => setTrip(r.data.trip)); }, []);

  if (!trip) return <div className="px-6 md:px-14 py-20"><p className="eyebrow text-ink/50">Loading…</p></div>;
  const docs = trip.documents || [];

  return (
    <div className="px-6 md:px-14 py-14 md:py-20 max-w-4xl">
      <p className="eyebrow">Documents</p>
      <h1 className="mt-4 font-serif text-4xl md:text-6xl text-jade font-light leading-[1.05]">Your travel papers.</h1>
      <p className="mt-4 text-ink/70 text-[15px] font-light max-w-xl">All vouchers, visas, and confirmations for your upcoming journey are kept here. Each document is also sent to your registered email.</p>

      <div className="mt-12 divide-y divide-mist/60 border-y border-mist/60" data-testid="portal-documents">
        {docs.map((d) => (
          <div key={d.id} data-testid={`portal-doc-${d.id}`} className="py-6 flex items-center gap-6">
            <FileText className="w-6 h-6 text-jade" strokeWidth={1} />
            <div className="flex-1">
              <p className="font-serif text-xl text-jade">{d.title}</p>
              <p className="text-[12px] tracking-[0.16em] uppercase text-ink/55 mt-1">{d.type} · Issued {d.issued_at}</p>
            </div>
            <button className="btn-secondary !text-jade !border-jade text-[11px] py-3 px-5 inline-flex items-center gap-2">
              <Download className="w-4 h-4" strokeWidth={1} /> Download
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
